<template>
  <div class="pb-50">
    <van-sticky>
      <van-nav-bar :border="false">
        <template slot="left">
          <img :src="homeData.topLogo" alt="" class="logo-site">
        </template>
        <template slot="right">
          <div class="flex align-center">
            <router-link class="relative" to="/message">
              <van-icon name="envelop-o" class="msg" />
              <span v-show="messageCount > 0" class="dot">{{ $store.state.messageCount }}</span>
            </router-link>
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>
    <mr-notice-bar :notice="homeData.topNotice"></mr-notice-bar>
    <div class="card-board">
      <div class="flex justify-between pl-10 pr-10">
        <van-button color="#0d0e15" class="br-10 w-150" @click="toggleBoard">{{ curBoardKey === 'MrAgentInfo' ?  '关闭' : '打开' }}统计</van-button>
        <van-button color="#0d0e15" class="br-10" @click="openPost">生成二维码海报</van-button>
      </div>
      <div class="pl-10 pr-10 mt-15"><mr-message style="margin: 15px 0;" :text="homeData.cpMsg"></mr-message></div>
      <component :is="curBoardKey" :agent="agent" :music="homeData.cpUser"></component>
    </div>

    <!-- 咨询 -->
    <template v-if="noticeList.length">
      <mr-advisory v-for="item in noticeList" :key="item.id" :data="item"></mr-advisory>
    </template>
    <!-- 咨询 -->

    <!-- 海报弹窗 -->
    <van-overlay :show="show" :lock-scroll="false" :custom-style="{ backgroundColor: 'rgba(0, 0, 0, .9)' }" @click="show = false">
      <div class="post-content" @click.stop>
        <div class="close" @click="show = false">X</div>
        <div class="row-wrapper">
          <div class="row">
            <div class="img" :class="{ 'selected': selectedType === 0 }">
              <h3>摇滚风格</h3>
              <div class="img-card"><img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a01.png" alt="" @click="selectedType = 0"></div>
            </div>
            <div class="img" :class="{ 'selected': selectedType === 5 }">
              <h3>摇滚风格(新)</h3>
              <div class="img-card"><img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/3-1.png" alt="" @click="selectedType = 5"></div>
            </div>
          </div>
          <div class="row">
            <div class="img" :class="{ 'selected': selectedType === 2 }">
              <h3>DJ风格</h3>
              <div class="img-card"><img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a03.png" alt="" @click="selectedType = 2"></div>
            </div>
            <div class="img" :class="{ 'selected': selectedType === 4 }">
              <h3>DJ风格(新)</h3>
              <div class="img-card"><img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/2-1.png" alt="" @click="selectedType = 4"></div>
            </div>
            <!-- <div v-if="false" class="img" :class="{ 'selected': selectedType === 3 }">
              <h3>抖音活动</h3>
              <img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a04.jpg" alt="" @click="selectedType = 3">
            </div> -->
          </div>
          <div class="row">
            <div class="img" :class="{ 'selected': selectedType === 1 }">
              <h3>演唱会风格</h3>
              <div class="img-card"><img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a02.png" alt="" @click="selectedType = 1"></div>
            </div>
            <div class="img" :class="{ 'selected': selectedType === 3 }">
              <h3>演唱会风格(新)</h3>
              <div class="img-card"><img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/1-1.png" alt="" @click="selectedType = 3"></div>
            </div>
          </div>
          <div class="row">
            <div class="img" :class="{ 'selected': selectedType === 6 }">
              <h3>古典风格</h3>
              <div class="img-card"><img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/4-1.png" alt="" @click="selectedType = 6"></div>
            </div>
          </div>
        </div>
        <div class="btn-wrapper">
          <van-button class="mr-16" size="large" style="border-radius: 10px;" @click="buildPost">生成海报</van-button>
          <!-- <van-button class="mr-16" size="large" style="border-radius: 10px;" @click="isPlus ? savePost() : buildPost()">{{ isPlus ? '保存海报' : '生成海报' }}</van-button>
          <van-button v-show="isPlus" color="#fc3159" size="large" style="border-radius: 10px;" @click="share">分享海报图</van-button> -->
        </div>
      </div>
    </van-overlay>
    <!-- 海报弹窗 -->

    <van-dialog v-model="showH5Img" show-confirm-button confirm-button-text="保存分享" show-cancel-button cancel-button-text="关闭" @confirm="share">
      <img v-if="shareImg" :src="shareImg" style="display: block;width: 80vw; margin: 20px auto 0;" />
    </van-dialog>

    <!-- 生成的容器 -->
    <div id="box" style="display: none;">
      <vue-qr :text="qrText" :size="100" :margin="5"></vue-qr>
      <canvas ref="canvas"></canvas>
    </div>
    <!-- 生成的容器 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getAgentDownNumber, getAgentHomeData, shareCount } from '@/api/agent.js'
import { getNoticeList } from '@/api/music.js'
import { getConfig } from '@/api/common.js'
import vueQr from 'vue-qr'
import MrNoticeBar from '@/pages/home/components/mr-notice-bar'
import MrMessage from '@/pages/home/components/mr-message'
import MrAdvisory from '@/pages/home/components/mr-advisory'
import MrAgentInfo from './components/agent-info'
import MrAgentCard from './components/agent-card'
const postType = [
  'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a01.jpg',
  'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a02.jpg',
  'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a03.jpg',
  // 'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/a04.png',
  'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/1-2.jpg',
  'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/2-2.jpg',
  'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/3-2.jpg',
  'http://sanka-static.oss-cn-beijing.aliyuncs.com/images/cover/4-2.jpg',
]
export default {
  name: 'AgentHome',
  components: { vueQr, MrNoticeBar, MrMessage, MrAgentInfo, MrAgentCard, MrAdvisory },
  data() {
    return {
      show: false, // 二维码海报弹窗
      showH5Img: false, // h5弹窗展示生成的海报图片
      selectedType: 0,
      curBoardKey: 'MrAgentInfo',
      qrImg: '', // 二维码图片
      qrText: '', // 生成二维码图片的填充地址
      shareImg: '', // 分享的图片
      agent: [], // 代理下线人数
      shareLink: '',
      context: null,
      canvas: null,
      homeData: {},
      noticeList: [],
      activityConfig: {} // 活动配置
    }
  },
  computed: {
    ...mapState(['agentInfo', 'isPlus', 'messageCount', 'currentRole', 'userInfo']),
  },
  async created() {
    this.$store.commit('TOGGLE_LOADING', true)
    this.$store.dispatch('getUserInfo')
    try {
      await this.getAgentHomeData()
      await this.getNoticeList()
      await this.getAgentDownNumber()
      await this.getConfig()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 初始化链接
      this.shareLink = location.origin + '/#/register?agent_uid=' + this.agentInfo.agent_id
      // 初始化canvas
      this.canvas = this.$refs.canvas
    })
  },
  methods: {
    async getNoticeList() {
      const res = await getNoticeList({ type: 'agent' })
      this.noticeList = res.data || []
    },
    async getAgentHomeData() {
      const res = await getAgentHomeData({})
      this.homeData = res.data
    },
    async getConfig() {
      const res = await getConfig({})
      this.activityConfig = res.data
    },
    toggleBoard() {
      this.curBoardKey = this.curBoardKey === 'MrAgentCard' ? 'MrAgentInfo' : 'MrAgentCard'
    },
    setCanvas(w, h) {
      // 设置canvas尺寸
      let devicePixelRatio = window.devicePixelRatio
      this.canvas.width = w * devicePixelRatio
      this.canvas.height = h * devicePixelRatio
      this.canvas.style.width = w + 'px'
      this.canvas.style.height = h + 'px'
      // 获取画笔
      this.context = this.canvas.getContext('2d')
      this.context.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0)
    },
    async getAgentDownNumber() {
      const boardList = [
        { name: '我的音乐人', prop: 'my_music' },
        { name: '已实名', prop: 'is_verify' },
        { name: '未实名', prop: 'no_verify' },
        { name: '代理贡献', prop: 'agent_con', detail: '说明：您的下层代理名下实名音乐人数量' },
        { name: '1级', prop: 'level_one', detail: '说明：您的直属下层代理名下实名音乐人数量' },
        { name: '2级', prop: 'level_two', detail: '说明：您的隔级代理名下是哪个音乐人数量' }
      ]
      const res = await getAgentDownNumber({})
      const data = res.data
      this.agent = boardList.map(val => ({
        label: val.name,
        value: data[val.prop],
        info: val.detail
      }))
    },
    openPost() {
      this.show = true
    },
    async savePost() {
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        await this.generateQrPost()
        window.uni.postMessage({
          data: {
            type: 'saveImg',
            img: this.shareImg
          }
        })
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async buildPost() {
      try {
        await this.generateQrPost()
      } catch (err) {
        alert(JSON.stringify(err))
      } finally {
        this.showH5Img = true
      }
    },
    async share() {
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        await this.generateQrPost()
        window.uni.postMessage({
          data: {
            type: 'share',
            img: this.shareImg
          }
        })
        await shareCount({})
        this.$store.dispatch('getUserInfo')
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async generateQrPost() {
      // 生成二维码海报
      this.qrImg = document.getElementById('box').querySelector('img')
      this.canvas = this.$refs.canvas
      // 绘制底图
      await this.draw('drawBg')
      // 绘制二维码
      // this.qrText = this.selectedType === 3 ? this.activityConfig.douyin_activity_h5_url + 'activity.html?agent_uid=' + this.agentInfo.agent_id + '#/hot-plan' : location.origin + '/#/register?agent_uid=' + this.agentInfo.agent_id
      this.qrText = location.origin + '/#/register?agent_uid=' + this.agentInfo.agent_id
      this.qrImg = document.getElementById('box').querySelector('img')
      await this.draw()
      this.shareImg = this.canvas.toDataURL('image/jpeg')
      this.qrText = ''
    },
    draw(type) {
      return new Promise((resolve, reject) => {
        if (type === 'drawBg') {
          let img = new Image()
          img.onload = () => {
            this.setCanvas(img.width, img.height)
            this.context.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width, img.height)
            // this.selectedType === 3 && this.drawText(img.width, img.height)
            resolve()
          }
          img.onerror= error => {
            reject(error)
          }
          img.crossOrigin="anonymous"
          img.src = postType[this.selectedType]
        } else {
          let w = parseInt(getComputedStyle(this.canvas).width)
          let h = parseInt(getComputedStyle(this.canvas).height)
          if (this.qrImg.src) { // qrimg对象存在则直接绘制图片
            this.context.drawImage(this.qrImg, 0, 0, this.qrImg.width, this.qrImg.height, w - this.qrImg.width - 55, h - this.qrImg.height - 100, this.qrImg.width, this.qrImg.height)
            resolve()
          } else { // 不存在则使用onload等待异步
            this.qrImg.onload = () => {
              this.context.drawImage(this.qrImg, 0, 0, this.qrImg.width, this.qrImg.height, w - this.qrImg.width - 55, h - this.qrImg.height - 100, this.qrImg.width, this.qrImg.height)
              resolve()
            }
            this.qrImg.onerror= error => {
              reject(error)
            }
          }
        }
      })
    },
    drawText(w, h) {
      // 设置字体
      this.context.font = '14px 黑体'
      // 设置对齐方式
      this.context.textAlign = 'center'
      // 设置颜色
      this.context.fillStyle = '#fff'
      // 标题
      this.context.fillText('参与活动的音乐作品', w / 2, h * 0.7)

      // 设置字体
      this.context.font = '20px bold 黑体'
      // 描述
      this.context.fillText('可获得200-300万真实抖音曝光流量', w / 2, h * 0.7 + 25)

      // 主办方信息
      this.context.font = '12px 黑体'
      // 设置对齐方式
      this.context.textAlign = 'left'
      this.context.fillText('主办信息: 本活动由三咖音乐全球通主办', 20, h * 0.7 + 77)
      this.context.fillText('声        名: 本活动无任何报名与参与费用，无任何潜在收费，', 20 , h * 0.7 + 94)
      this.context.fillText('                  一切以本活动为由的收费行为均为欺诈，请勿上当。', 20 , h * 0.7 + 111)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/home.scss";
.card-board{
  margin: 15px;
  padding: 16px 6px;
  border-radius: 16px;
  box-shadow: 0 0 6px 0#D8D8D8;
  background-color: #fff;
  .img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}
.post-content{
  height: 80vh;
  color: #fff;
  padding: 40px 10px;
  .close{
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    background: #000;
    border-radius: 50%;
    text-align: center;
    padding: 5px;
    font-size: 14px;
    box-sizing: content-box;
  }
  .row{
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    height: 200px;
    text-align: center;
    .img-card{
      width: 150px;
      height: 140px;
      border: 1px solid transparent;
      border-radius: 10px;
      overflow: hidden;
    }
    .selected{
      position: relative;
      &::after{
        font-family: 'vant-icon';
        content: '\F0C8';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, calc(-50% + 10px), 0);
        z-index: 1;
        color: red;
        font-size: 68px;
      }
      .img-card{
        border-color: red;
      }
      img{
        transform: scale(1.03);
      }
    }
    h3{
      height: 18px;
      line-height: 18px;
      font-size: 14px;
      margin-bottom: 10px;
    }
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
      transition: all .2s;
    }
  }
  .btn-wrapper{
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
.row-wrapper{
  height: 430px;
  overflow: hidden;
  overflow-y: auto;
  border: 5px solid transparent;
}
.mr-bgc{
  background-color: rgba(0, 0, 0, .5);
}
</style>
